import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HowItWorksVideoModal from 'components/modals/HowItWorksVideoModal';
import { toggleHowItWorksVideoModalAction } from 'modules/layout/store/actions';
import buildResourceUrl from 'utils/buildResourceUrl';
import posterImg1 from 'assets/img/affiliate-posters/poster1.png';
import posterImg2 from 'assets/img/affiliate-posters/poster2.png';
import posterImg3 from 'assets/img/affiliate-posters/poster3.png';
import posterImg4 from 'assets/img/affiliate-posters/poster4.png';
import posterImg5 from 'assets/img/affiliate-posters/poster5.png';
import posterImg6 from 'assets/img/affiliate-posters/poster6.png';

import classes from './AmbassadorManagement.module.scss';

const posterImages = [
  posterImg1,
  posterImg2,
  posterImg3,
  posterImg4,
  posterImg5,
  posterImg6,
];

const videoSteps = [3, 0, 4, 5, 1, 2];

const AmbassadorVideos = () => {
  const query = useSelector(({ router }) => router.location.query);
  const videoUrlPlaceholder = useSelector(
    (state) => state.app.config.endpoints.media.videos.standart
  );
  const videosData = useSelector((state) => state.app.enums.videos);

  const dispatch = useDispatch();
  const [modalVideo, setModalVideo] = useState(null);
  const [modalPoster, setModalPoster] = useState(null);
  const videoRef = useRef();
  const handlePause = useCallback((e) => e.target.blur(), []);

  const videosArr = useMemo(() => {
    const videos = [];
    if (!videosData) return [];
    videoSteps.map((step, index) =>
      videos.push({
        video: buildResourceUrl(
          videoUrlPlaceholder,
          null,
          null,
          videosData[step]
        ),
        poster: posterImages[index],
        label: `step-${index + 1}`,
      })
    );
    return videos;
  }, [videoUrlPlaceholder, videosData]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    if (Object.keys(query).length && query.videoUrl) {
      const neededVideo = videosArr.find((obj) => obj.label === query.videoUrl);
      if (!neededVideo) return;
      setModalVideo(neededVideo.video);
      setModalPoster(neededVideo.poster);
      dispatch(toggleHowItWorksVideoModalAction(true));
    }
  }, [dispatch, query, videosData, videosArr]);

  return (
    <>
      <section className={classes.root}>
        <div className={classes.banner}>
          <div className="d-flex align-items-center">
            <h2 className="ml-1 text-md text-uppercase font-semi-bold">
              Ambassador onboarding
            </h2>
          </div>
        </div>
        <div className={classes.mainWrapper}>
          {!!videosArr.length && (
            <div className={classes.mainVideo}>
              {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
              <video
                ref={videoRef}
                src={videosArr[0].video}
                preload="metadata"
                onPause={handlePause}
                controls
                className={classes.video}
                poster={videosArr[0].poster}
              />
            </div>
          )}
          <div className={classes.videosSection}>
            {videosArr.map((videoItem, index) =>
              index === 0 ? null : (
                // eslint-disable-next-line jsx-a11y/media-has-caption
                <video
                  key={videoItem.video}
                  ref={videoRef}
                  src={videoItem.video}
                  preload="metadata"
                  onPause={handlePause}
                  controls
                  poster={videoItem.poster}
                />
              )
            )}
          </div>
        </div>
      </section>
      <HowItWorksVideoModal posterImg={modalPoster} video={modalVideo} />
    </>
  );
};

export default AmbassadorVideos;
